import React from 'react';

const ErrorProject=()=>{
	return(
		<div className="report-section default d-flex justify-content-center pt-5" id="error-project">
		    <div className="container">

		        <div className="row only-first">
		            <div className="report-box">
		                <div className="report-box-header red">
		                    <span className="glyphicon glyphicon-alert fa-fw"> </span>
		                    SORRY, WE COULDN'T FIND THE PROJECT
		                </div>
		                <div className="report-box-text">
		                    You tried to access a project report that doesn't exist or that is not accessible to you.<br/>
		                    Please check the URL you entered - in case you still think you should be able to access this page,
		                    please contact <a href="mailto:support@meterian.com">Meterian support</a>.
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	)
}


const LoginRequired=()=>{
    return(
    	<div className="container d-flex justify-content-center pt-5" id="login-required">
	        <div className="row">
	            <div className="col-md-8">
	                <div className="report-box" >
	                    <div className="report-box-header orange">
	                        <span className="glyphicon glyphicon-alert fa-fw"> </span>
	                        &nbsp; A LOGIN IS REQUIRED TO ACCESS THIS REPORT
	                    </div>
	                    <div className="report-box-text">
	                        This report contains a project which requires a login to be accessed. <br/>
	                        Please login with your credentials, the system will make sure you have
	                        the required security clearance and will present you with the updated report.<br/>
	                        Please contact <a href="mailto:support@meterian.com">Meterian support</a> if you have any
	                        further question.
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
    )
}
export  {ErrorProject,LoginRequired};